var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"fieldset-class"},[_c('legend',{staticClass:"legend-class"},[_c('h5',[_vm._v(_vm._s(_vm.legend))])]),_vm._t("default",[_vm._v("...")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }